import { Injectable, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { Router, NavigationExtras } from '@angular/router';
import { from, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { IMAGE_FARM_URL } from '@fb-tool-front/overlay-editor/constants/overlay.constants';
import { tuiPure } from '@taiga-ui/cdk';
import { AuthService } from './auth.service';
import { ClientSubscriptionTypes } from '@fb-tool-front/shared/constants/auth.constants';

@Injectable({
  providedIn: 'root'
})
export class HelpersService {
  constructor(private http: HttpClient, private sanitizer: DomSanitizer) {}

  updateQueryParams(router: Router, extras?: NavigationExtras) {
    router.navigate([], extras);
  }

  public convertSrcToFileOjb(src: string, fileName: string = 'unknown'): Observable<File> {
    return this.http
      .get(`${IMAGE_FARM_URL}fetch/${this.sanitizer.sanitize(SecurityContext.URL, src)}`, {
        responseType: 'blob'
      })
      .pipe(
        switchMap((res: any) =>
          from(res.arrayBuffer()).pipe(map((buf: ArrayBuffer) => ({ buf, type: res.type })))
        ),
        map(res => new File([res.buf], fileName, { type: res.type }))
      );
  }
}
